import "./App.css"
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom"
import Navbar from "./components/navbar/Navbar"
import Login from "./pages/Login"
import Signup from "./pages/Signup"
import AdminRoutes from "./routes/AdminRoutes"
import ConfirmBookingPage from "./pages/ConfirmBooking"
import BookingCalender from "./pages/BookingCalender"
import { BookingProvider } from "./context/BookingContext"
import { AuthProvider } from "./context/AuthContext"
import SuccessPage from "./pages/Success"
import Fail from "./pages/Fail"
import HomePage from "./pages/HomePage"
import AboutUs from "./pages/AboutUs"
import { Box, ThemeProvider } from "@mui/material"
import theme from "./components/theme/Theme"
import Dashboard from "./components/user-dashboard/Dashboard"
import Footer from "./components/footer/Footer"
import UserForm from "./pages/UserForm"
import PasswordReset from "./pages/PasswordReset"
import ResetPasswordPage from "./pages/ResetPasswordPage"
import Listings from "./pages/Listing"
import { useEffect, useState } from "react"
import { ToastContainer } from "react-toastify"
import Memberships from "./pages/Memberships"
import MembershipSuccess from "./pages/MembershipSuccess"
import MembershipCancel from "./pages/MembershipCancel"
import Programs from "./pages/Programs"
import ProgramSuccess from "./pages/ProgramSuccess"
import ProgramFail from "./pages/ProgramFail"
import ProgramDetails from "./pages/ProgramDetails"
import AdminLayout from "./layouts/AdminLayout"
import { loadGoogleAds } from "./utils/loadGoogleAds"
import { loadSpotifyAds } from "./utils/loadSpotifyAds"
import WebsitePopupBanner from "./components/admin/WebsitePopupBanner"
import OfferBanner from "./components/admin/OfferBanner"
import UnsubscribePromotions from "./pages/UnsubscribePromotions"

function App() {
  const [userType, setUserType] = useState(localStorage.getItem("userType"))

  useEffect(() => {
    loadGoogleAds()
    loadSpotifyAds()
  }, [])

  useEffect(() => {
    const checkUserType = () => {
      const currentUserType = localStorage.getItem("userType")
      setUserType(currentUserType)
    }

    checkUserType()
    window.addEventListener("storage", checkUserType)
    window.addEventListener("userTypeChanged", checkUserType)

    return () => {
      window.removeEventListener("storage", checkUserType)
      window.removeEventListener("userTypeChanged", checkUserType)
    }
  }, [])

  // Helper function to get default admin route based on user type
  const getDefaultAdminRoute = () => {
    if (userType === "employee" || userType === "employee_admin") {
      return "/admin/manage-bookings"
    }
    return "/admin/dashboard"
  }

  return (
    <>
      <ThemeProvider theme={theme}>
        <AuthProvider>
          <BookingProvider>
            <Router>
              {userType === "admin" || userType === "employee" || userType === "employee_admin" ? (
                <Routes>
                  <Route
                    path="/program-success"
                    element={
                      <AdminLayout>
                        <ProgramSuccess />
                      </AdminLayout>
                    }
                  />
                  <Route
                    path="/program-failed"
                    element={
                      <AdminLayout>
                        <ProgramFail />
                      </AdminLayout>
                    }
                  />
                  <Route path="/unsubscribe-promotions" element={<UnsubscribePromotions />} />
                  <Route path="/admin/*" element={<AdminRoutes />} />
                  <Route path="/*" element={<Navigate to={getDefaultAdminRoute()} replace />} />
                </Routes>
              ) : (
                <Routes>
                  <Route path="/admin/*" element={<AdminRoutes />} />

                  <Route
                    path="/*"
                    element={
                      <>
                        <Box
                          sx={{
                            position: "sticky",
                            top: 0,
                            zIndex: 1100,
                          }}
                        >
                          <OfferBanner />
                          <Navbar />
                        </Box>
                        <WebsitePopupBanner />
                        <Routes>
                          <Route path="/" element={<HomePage />} />
                          <Route path="/about" element={<AboutUs />} />
                          <Route path="/login" element={<Login />} />
                          <Route path="/signup" element={<Signup />} />
                          <Route path="/listings" element={<Listings />} />
                          <Route path="/book/:id" element={<BookingCalender />} />
                          <Route path="/confirm-booking/:id" element={<ConfirmBookingPage />} />
                          <Route path="/booking-success" element={<SuccessPage />} />
                          <Route path="/dashboard" element={<Dashboard />} />
                          <Route path="/booking-failed" element={<Fail />} />
                          <Route path="/user-form" element={<UserForm />} />
                          <Route path="/forgot-password" element={<PasswordReset />} />
                          <Route path="/reset-password/" element={<ResetPasswordPage />} />
                          <Route path="/unsubscribe-promotions" element={<UnsubscribePromotions />} />
                          <Route path="/memberships" element={<Memberships />} />
                          <Route path="/membership/success" element={<MembershipSuccess />} />
                          <Route path="/membership/cancel" element={<MembershipCancel />} />
                          <Route path="/programs" element={<Programs />} />
                          <Route path="/programs/:programId" element={<ProgramDetails />} />
                          <Route path="/program-success" element={<ProgramSuccess />} />
                          <Route path="/program-failed" element={<ProgramFail />} />
                        </Routes>
                        <Footer />
                      </>
                    }
                  />
                </Routes>
              )}
            </Router>
          </BookingProvider>
        </AuthProvider>
      </ThemeProvider>
      <ToastContainer />
    </>
  )
}

export default App
